import React from 'react';
import { Box, Typography } from '@material-ui/core';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AutorenewIcon from '@material-ui/icons/Autorenew';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import type { SvgIconComponent } from '@material-ui/icons';
import { VALIDATION_SOURCES } from '../constants';
import type { ValidationChangeCardProps, ValidationSource } from '../types';
import useStyle from '../styles';

const ICON_BY_SOURCE: Record<ValidationSource, SvgIconComponent> = {
  DGII: AccountBalanceIcon,
  BILLET: AutorenewIcon,
  CARDNET: CreditCardIcon,
};

// Una validación que cambió. La tarjeta no compara nada: recibe las frases ya resueltas y solo
// decide con qué color remata el valor actual.
const ValidationChangeCard = ({ change }: ValidationChangeCardProps) => {
  const classes = useStyle();
  const { title, currentRowLabel } = VALIDATION_SOURCES[change.source];
  const Icon = ICON_BY_SOURCE[change.source];

  const cardClassBySource: Record<ValidationSource, string> = {
    DGII: classes.changeCardDgii,
    BILLET: classes.changeCardBillet,
    CARDNET: classes.changeCardCardnet,
  };

  return (
    <Box className={`${classes.changeCard} ${cardClassBySource[change.source]}`}>
      <Box className={classes.changeCardHeader}>
        <Icon fontSize="small" />
        <Typography component="span" className={classes.changeCardTitle}>
          {title}
        </Typography>
      </Box>

      <Box className={classes.changeRow}>
        <span className={classes.changeRowLabel}>{currentRowLabel}</span>
        <span
          className={change.isAdverse
            ? classes.changeRowValueAdverse
            : classes.changeRowValueFavorable}
        >
          {change.currentLabel}
        </span>
      </Box>
    </Box>
  );
};

export default ValidationChangeCard;
